var template_character_count = 'Characters left : <span style="font-weight: bold;">{maxlength}</span>';
var sku = $( '#pmc_product_sku' ).val();

$( document ).ready( function(){
	// Smooth Scroll to the Personalise Div
  	$(document).on( 'click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top -175
        }, 1000);
    });
  console.log( 'here' );
  
  
  // Build the PMC personalisation form
  $( '.pmc_personalisation_fields' ).each( function(){
  	var data_criteria = $( this ).attr( 'data-criteria' );
    var criterias = data_criteria.split( "|][|" );
    console.log( criterias );
    var id = $( this ).attr( "id" );
    var maxlength = criterias[ 1 ];
    var is_required = ((criterias[ 2 ]).toLowerCase()=="required")?true:false;
    var label = criterias[ 0 ] + ((is_required)?"*":"");
    var label_clean = criterias[ 0 ];
    
    // Set Label Text
    $( '#label_' + id ).text( label );
    
    // Set maxlength of the field
    $( '#' + id ).attr( 'maxlength', criterias[ 1 ] );
    
    // Set whether the field is required or not
    if( is_required )
    	$( '#' + id ).attr( 'required', 'required' );
    
    // Set initial character count display
    $( this ).next( 'p.character_count' ).html( get_character_count( maxlength ) );
    
    // Set the name="properties[]" for personalisation input fields to display them on the cart page
    $( this ).attr( 'name', 'properties[' + label_clean + ']' );
    
  });
  
  
  
  generate_preview();
  // Generate Preview on blur of the field
  $( '.pmc_personalisation_fields' ).on( 'blur', function(){
    generate_preview();
    
  });
  
  // Dynamic Character Count Display
  $( '.pmc_personalisation_fields' ).on( 'keyup', function(){
    console.log( "keydown" );
    var length = parseInt( $( this ).val().length );
    var maxlength = parseInt( $( this ).attr( 'maxlength' ) );
    var remaining = maxlength - length;
    $( this ).next( '.character_count' ).html( get_character_count( remaining ) );
  
  });

  // Generate Lead Times, loop through JSON array as loopingis not working with Liquid code
  var postages = JSON.parse( $( '#postages_json' ).html() );
  console.log( postages );
  if( postages.length > 0 ){
    var tr = "";
    $.each( postages, function( index, item ){
      var td = "<tr><td>" + item.postage + "</td></tr>";
      tr += td;
    });
    
    $( '.product_delivery_information table tbody' ).append( tr );  
  }
  else{
    var td = "<tr><td>No information available</td></tr>";
    $( '.product_delivery_information table tbody' ).append( tr );
  }
  
});

function get_character_count( count ){
  return template_character_count.replace( '{maxlength}', count );
}

function generate_preview(){
  var count = 1;
    var lines = "{$";
    $( '.pmc_personalisation_fields' ).each( function(){
      lines += "Line" + (count++) + "=" + $( this ).val() + ";";    	
    });
    lines += "$}";
    // console.log( lines );
  	
    data = {
      'what_do_you_want' : 'generate_preview',
      'sku' : sku,
      'lines' : lines
    };

    $.ajax({
      type : 'POST',
      url : '/apps/sc_webservice/webservice.php',
      crossDomain: true,
      data: data,
      //dataType: 'json',
      success : function( returned_data ){
        console.log( returned_data );
        //console.log( 'here' );
        $( '#pmc_personalised_image' ).attr( 'src', returned_data );

      }
    });

}